module.exports = __webpack_public_path__ + "media/images/success-notice-35afcf38cb07d34bd88f2e106475003a.svg";